module.exports = __webpack_public_path__ + "static/media/news-june-event.66a97954.jpg";